import Backbone from 'backbone';

export default Backbone.Model.extend({
  initialize() {
    // this.set('foo', 'bar');
  },
});



// WEBPACK FOOTER //
// /Users/m802941/WebstormProjects/2020/campaigns/shop-the-look-pdp/src/js/models/shop-the-look-pdp.js